import { Box, Typography } from "@mui/material";
import React from "react";

type Props = {
    label:string;
    value:string
}
const CustomLabel = ({label , value}:Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="h7" >{label}</Typography>
      <Typography variant="body1">{value}</Typography>
    </Box>
  );
};

export default CustomLabel;
